/**
 * Tabla única de permisos por rol del negocio (arquitectura 2.9, «Identity»; roles de la 2.15).
 * Los servicios la aplican con `@Permiso(clave)` y los frentes la usan para mostrar u ocultar
 * pantallas y botones, así que el menú y el API nunca discrepan.
 * Super Admin, Soporte, Operación y las cuentas de servicio no entran aquí: son roles del realm.
 */
import { ROLES_LOTERO } from './roles.js';
export { CUENTA_DEL_ROL, DESCRIPCION_ROL, NOMBRE_ROL, ROLES_LOTERO, ROLES_PROVEEDOR, } from './roles.js';
const TODOS = ROLES_LOTERO;
export const PERMISOS = {
    // Plataforma: datos del lotero, suscripción, dominios, sitio y cuenta de cobro.
    'lotero.administrar': ['dueno'],
    'usuarios.administrar': ['dueno', 'gerente'],
    // Inventario.
    'vehiculos.ver': TODOS,
    'vehiculos.registrar': ['dueno', 'gerente', 'comprador', 'vendedor', 'patio', 'desarmador'],
    'vehiculos.estado': ['dueno', 'gerente', 'vendedor', 'patio', 'taller', 'mecanico', 'desarmador'],
    'vehiculos.baja': ['dueno', 'gerente'],
    'documentos.subir': TODOS,
    'piezas.administrar': ['dueno', 'gerente', 'patio', 'desarmador'],
    'piezas.estado': [
        'dueno',
        'gerente',
        'vendedor',
        'patio',
        'taller',
        'mecanico',
        'desarmador',
        'mostrador',
    ],
    // Montos: costos, márgenes, compras y valuaciones. Patio, taller, mecánico, desarmador,
    // mostrador y operador no los ven.
    'montos.ver': ['dueno', 'gerente', 'comprador', 'vendedor', 'contador'],
    /** El taller solo registra costos de la etapa de reparación (lo valida finance-svc). */
    'costos.registrar': ['dueno', 'gerente', 'contador', 'taller'],
    'costos.anular': ['dueno', 'gerente', 'contador'],
    'compras.registrar': ['dueno', 'gerente', 'comprador', 'vendedor', 'contador'],
    'valuaciones.registrar': ['dueno', 'gerente', 'comprador', 'vendedor', 'contador'],
    'casco.vender': ['dueno', 'gerente', 'contador', 'patio'],
    // Importación: el patio sigue los pasos físicos del cruce.
    'importacion.ver': ['dueno', 'gerente', 'comprador', 'vendedor', 'contador', 'patio'],
    'importacion.abrir': ['dueno', 'gerente', 'comprador', 'vendedor', 'contador'],
    'importacion.pasos': ['dueno', 'gerente', 'vendedor', 'contador', 'patio'],
    'importacion.pedimento': ['dueno', 'gerente', 'contador'],
    // Comercial.
    'publicaciones.administrar': ['dueno', 'gerente', 'vendedor'],
    'leads.atender': ['dueno', 'gerente', 'vendedor', 'mostrador'],
    'pedidos.ver': ['dueno', 'gerente', 'vendedor', 'patio', 'mostrador'],
    'pedidos.estado': ['dueno', 'gerente', 'vendedor', 'mostrador'],
    // Taller.
    'estimaciones.ver': ['dueno', 'gerente', 'comprador', 'taller', 'vendedor'],
    'estimaciones.decidir': ['dueno', 'gerente', 'taller'],
    'tarifas.administrar': ['dueno', 'gerente'],
    'ordenes.ver': TODOS,
    'ordenes.trabajar': ['dueno', 'gerente', 'taller', 'mecanico'],
    'ordenes.cancelar': ['dueno', 'gerente'],
    // Proveedores (lado del lotero que contrata).
    'proveedores.solicitar': ['dueno', 'gerente', 'taller'],
    'proveedores.ver': ['dueno', 'gerente', 'taller', 'contador'],
    'proveedores.adjudicar': ['dueno', 'gerente'],
    'proveedores.pagar': ['dueno', 'gerente', 'contador'],
    // Portal de Proveedores (lado del proveedor que oferta).
    'portal.ver': ['dueno', 'taller', 'vendedor', 'operador'],
    'portal.perfil': ['dueno'],
    'portal.ofertar': ['dueno', 'taller', 'vendedor', 'operador'],
    // Ayuda, tickets y derechos ARCO (arquitectura 2.12): toda persona del lotero.
    'soporte.usar': TODOS,
    // Encargos a Siniestrados (arquitectura 2.15, compra por encargo): pedir un auto, ver la
    // propuesta con su anticipo y decidir. Ven montos, así que patio y taller quedan fuera.
    'encargos.ver': ['dueno', 'gerente', 'comprador', 'vendedor', 'contador'],
    'encargos.pedir': ['dueno', 'gerente', 'comprador', 'vendedor'],
    'encargos.decidir': ['dueno'],
    // Pantallas por rol del MVP3 (arquitectura 2.15): el mostrador vende piezas; el desarme y
    // las tareas del mecánico usan piezas.administrar y ordenes.trabajar.
    'mostrador.vender': ['dueno', 'gerente', 'vendedor', 'mostrador'],
};
/** Roles que tienen el permiso. */
export function rolesCon(clave) {
    return [...PERMISOS[clave]];
}
/** ¿Alguno de los roles tiene el permiso? */
export function puede(roles, clave) {
    return PERMISOS[clave].some((rol) => roles.includes(rol));
}
export function esRolLotero(valor) {
    return ROLES_LOTERO.includes(valor);
}
//# sourceMappingURL=index.js.map